import React from "react";
import { OptionProps } from "@/modules/common/types";
import FormFieldByType from "@/modules/lead-page/components/lead-info/edit-fields/status/forms/form-factory/form-field-by-type";
import { FieldsResponse } from "@/modules/common/dtos/index.v2";
import Grid from "@mui/material/GridLegacy";

interface FormItemRendererProps {
  field: FieldsResponse;
  control: any;
  watch: any;
  setValue: any;
  setOptions?: React.Dispatch<
    React.SetStateAction<Record<string, OptionProps>>
  >;
}

const FormItemRenderer: React.FC<FormItemRendererProps> = ({
  field,
  control,
  setValue,
}) => {
  const name = field.field.key || field.field.uid;

  const isMulti = field.isMulti;
  const rules: Record<string, any> = {};
  if (field.required) {
    rules.required = true;
  }

  if (field.field.isEmail) {
    rules.email = true;
  }

  if (field.field.isPhone) {
    rules.phone = true;
  }

  if (field.field.customRegex && field.field.customRegex.length <= 500) {
    try {
      rules.pattern = new RegExp(field.field.customRegex);
    } catch {
      // Skip invalid regex patterns
    }
  }

  if (field.field.minValue !== null) {
    rules.min = field.field.minValue;
  }
  if (field.field.maxValue !== null) {
    rules.max = field.field.maxValue;
  }

  if (field.field.minDate) {
    rules.minDate = new Date(field.field.minDate);
  }
  if (field.field.maxDate) {
    rules.maxDate = new Date(field.field.maxDate);
  }
  if (field.field.minTime) {
    rules.minTime = field.field.minTime;
  }
  if (field.field.maxTime) {
    rules.maxTime = field.field.maxTime;
  }

  if (field.field.defaultValue) {
    rules.defaultValue = field.field.defaultValue;
  }

  return (
    <Grid
      data-testid={`status-form-field-${name}`}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "-1rem",
        paddingY: "16px",
      }}
      item
      mobile={12}
      // tablet={status_form_field.field_type === "location" ? 12 : 6}
      key={field.id}
    >
      <FormFieldByType
        fieldType={field.field.type}
        fullName={name || ""}
        control={control}
        isMulti={isMulti}
        fieldRules={rules}
        options={field.field.dropdowns}
        status_form_field={field}
        setValue={setValue}
      />
    </Grid>
  );
};

export default FormItemRenderer;
